import { useNavigate } from "react-router-dom";
import "../../../styles/components/home/categories/homeCategoryCardContainer.scss";

export const HomeCategoryCardContainer = ({ category }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/categories/${category.id}`);
  };

  return (
    <div className="homeCategoryCardContainer" onClick={handleClick}>
      <div className="imageContainer">
        <img src={category.imageURL} alt={category.name} />
      </div>
      <div className="detailsContainer">
        <h3>{category.categoryName}</h3>
      </div>
    </div>
  );
};

export default HomeCategoryCardContainer;
